export default {
    home: 'Home',
    auth: 'Welcome',
    admin: 'Admin',
}
